<template>
  <div class="error-404-content">
    <main class="section p-12">
      <div class="container">
        <div class="text-[5.7142857143rem] font-bold text-white mb-0 leading-[6.4285714rem]">
          Uh oh!
        </div>
        <p class="text-white mb-[4.2857142857rem] text-[1.2857143rem] font-medium">
          We can't seem to find the page you're looking for.
        </p>
        <div>
          <NuxtLink
            :to="{ path: '/', query: {} }"
            id="home-button"
            aria-label="Go to home page"
            title="Home"
            class="px-[1rem] pt-[0.5rem] pb-[0.4285714rem] bg-ash-500 text-white text-[1rem] font-normal rounded-[0.4285714rem] hover:bg-ash-800 h-[2.5714286rem] inline-block transition"
            external
          >
            Head Home
          </NuxtLink>
        </div>
      </div>
    </main>
  </div>
</template>
